import * as React from 'react';
import { useTransition, animated, UseTransitionProps } from 'react-spring';

import { Col } from '@notino/react-styleguide';
import { GetProductsByIdBatchedQuery } from '@notino/shared/definitions/types';

import ProductItem from '@components/Universals/ProductItem';
import {
  IProductOuterProps,
  IProductItemProps,
} from '@components/Universals/ProductItem/model';
import { ProductListHolder } from '@components/Universals/ProductListHolder';

import { useRegisteredWatchdog } from './WishlistPager/useRegisteredWatchdog';

const columns = { xs: 6, md: 3 };
const animationConfiguration: UseTransitionProps = {
  from: { opacity: 1 },
  enter: { opacity: 1 },
  leave: { opacity: 0 },
  keys: (item: GetProductsByIdBatchedQuery['vpProductByIds'][number]) =>
    item?.id,

  config: {
    duration: 400,
    clamp: true,
  },
};

type AnimatedProductListProps = Pick<
  IProductItemProps,
  'canSpaRedirect' | 'showAddToCartModal'
> & {
  products: GetProductsByIdBatchedQuery['vpProductByIds'];
  owner?: string; // owner id is provided when displaying shared wishlist
  productItemProps?: IProductOuterProps;
};

const AnimatedProductList = ({
  products,
  owner = null,
  productItemProps = {},
  showAddToCartModal,
  canSpaRedirect,
}: AnimatedProductListProps) => {
  const transitions = useTransition(products, animationConfiguration);

  const { registeredEmails } = useRegisteredWatchdog({ products });

  return (
    <ProductListHolder>
      {transitions((style, product, _, index) => {
        const hasRegisteredWatchdog = Boolean(
          registeredEmails &&
            registeredEmails[product.catalogId] &&
            registeredEmails[product.catalogId].length > 0
        );

        return (
          <Col key={product.id} {...columns}>
            <animated.div style={style} key={product.id}>
              <ProductItem
                product={product}
                hasRegisteredWatchdog={hasRegisteredWatchdog}
                showWishlistButton={!owner}
                position={index + 1}
                showAddToCartModal={showAddToCartModal}
                canSpaRedirect={canSpaRedirect}
                useMasterUrl={false}
                {...productItemProps}
              />
            </animated.div>
          </Col>
        );
      })}
    </ProductListHolder>
  );
};

export default AnimatedProductList;
